import React from 'react'
import BarChart from 'recharts/es6/chart/BarChart'
import Bar from 'recharts/es6/cartesian/Bar'
import Legend from 'recharts/es6/component/Legend'
import XAxis from 'recharts/es6/cartesian/XAxis'
import YAxis from 'recharts/es6/cartesian/YAxis'
import CartesianGrid from 'recharts/es6/cartesian/CartesianGrid'
import Tooltip from 'recharts/es6/component/Tooltip'
// import { Area } from 'recharts'
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer'

// const ChartBar = ({ data }) => (
export default class ChartBar extends React.PureComponent {
    state = {
        data: [],
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                data: this.props.data,
            })
        }, 2000)
    }

    // componentWillReceiveProps
    static getDerivedStateFromProps(nextProps, prevState) {
        // console.log(prevState);
        
        if(nextProps.data === prevState.data){
            return null;
        } else {
            return { data: nextProps.data}
        }
    }

    render() {
        return (
            <ResponsiveContainer height="100%" width="100%">
                <BarChart
                    data={this.state.data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar animationDuration={1500} dataKey="pv" fill="#8884d8" />
                    <Bar animationDuration={1500} dataKey="uv" fill="#82ca9d" />
                </BarChart>
            </ResponsiveContainer>
        )
    }
}
